// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b7e86338","453":"f2c09ba4","619":"1a6323ab","636":"abe62b7a","914":"8cdeab58","961":"dbf17a63"}[chunkId] + ".chunk.js";
};